import React                               from 'react';
import { finishPlating as defaultOptions } from 'pu-data/SelectOptions';
import { finishPlating as tooltip }        from 'pu-data/Tooltips';
import SelectComponent                     from './SelectComponent';

const FinishPlating = (props) => {
  const name = 'finish_plating';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <SelectComponent
      label={props.label}
      required={props.required}
      name={name}
      onChange={props.onChange || onChange}
      options={props.options}
      tooltip={tooltip}
      selected={props.parameters[name]}
      groupName={props.groupName} />
  );
};

FinishPlating.defaultProps = {
  label   : 'Finish<br class="d-none d-lg-block d-xl-none" /> Plating',
  options : defaultOptions,
  required: true,
};

export default FinishPlating;
